import { useState, useContext } from "react";
import { useSelector } from "react-redux";
import { RequestLoader, ToastContext } from "../../../hooks/context";
import { cleanObject, getRandomIntInclusive } from "../../../helpers";
import { useCreateCashBankJournalEntry } from "../../../hooks/api/mutations/useAccounting";
import { useGetAllChartOfAccounts } from "../../../hooks/api/queries";

const useAddDebitToBankAccount = ({
  closeWidget,
  mainChartAccount,
  type,
  handleFetchBankTransaction,
  refetchChartAccountDetails,
}) => {
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const { currency_code } = useSelector(
    (state) => state.profileDetailsReducer?.businessDetails,
  );
  const { setRequestLoaderProgress } = useContext(RequestLoader);
  const triggerToast = useContext(ToastContext);
  const [originatingAccountDetails, setOriginatingAccountDetails] = useState();
  const [destinationAccountDetails, setDestinationAccountDetails] = useState();
  const [storeDetails, setStoreDetails] = useState();
  const createCashBankJournalEntryMutation = useCreateCashBankJournalEntry();

  const [fundsMovementDetails, setfundsMovementDetails] = useState({
    amount: "",
    description: "",
    store_id: "",
    destination_account_id: "",
    originating_account_id: mainChartAccount.id,
  });

  const handleFundsMovement = () => {
    setRequestLoaderProgress(getRandomIntInclusive(10, 50));
    const data = { ...fundsMovementDetails };

    createCashBankJournalEntryMutation.mutate(cleanObject(data), {
      onSuccess: () => {
        handleFetchBankTransaction();
        refetchChartAccountDetails();
        triggerToast(
          `${type === "deposit" ? "Deposit" : type === "transfer" ? "Transfer" : "Withdraw"} added successfully`,
          "success",
        );
        closeWidget();
      },
      onSettled: () => setRequestLoaderProgress(100),
    });
  };
  const {
    isLoading: isLoadingBankAccountsList,
    data: chartOfAccounts,
    refetch: handleFetchBankAccountsList,
  } = useGetAllChartOfAccounts({ sub_account_type: "cash_and_bank" });

  return {
    fundsMovementDetails,
    chartOfAccounts,
    currency_code,
    isLoadingBankAccountsList,
    handleFetchBankAccountsList,
    setfundsMovementDetails,
    storeList,
    handleFundsMovement,
    createCashBankJournalEntryMutation,
    originatingAccountDetails,
    destinationAccountDetails,
    setOriginatingAccountDetails,
    setDestinationAccountDetails,
    setStoreDetails,
    storeDetails,
  };
};

export default useAddDebitToBankAccount;
